export const GET_TEACHER_HOME_DATA = "GET_TEACHER_HOME_DATA";
